export default ({ wrappedFuncToCall, history }) => ({ data: { auth } }) => wrappedFuncToCall({ auth }, history);
